import React from 'react';
import { Checkbox } from './ui/checkbox';
import { Label } from './ui/label';
import { Shield, AlertTriangle } from 'lucide-react';

export function DataSecurityConsent({ checked, onCheckedChange, className = '' }) {
  return (
    <div className={`bg-amber-50 border border-amber-200 rounded-xl p-4 sm:p-6 ${className}`}>
      <div className="flex items-center gap-2 mb-4">
        <Shield className="w-5 h-5 text-amber-600" />
        <h3 className="font-bold text-amber-800">Data Security & Liability Waiver</h3>
      </div>
      
      <div className="text-sm text-amber-900 space-y-3 mb-5">
        <p className="font-medium">I acknowledge and agree that:</p>
        
        <div className="space-y-2 ml-1">
          <p>
            <strong>1. No Voluntary Sharing:</strong> MISYOU will not voluntarily share my personal data with third parties for commercial purposes.
          </p>
          
          <p>
            <strong>2. Security Limitations:</strong> Despite reasonable security measures, no digital platform is immune to cyber threats. MISYOU cannot guarantee protection against hacking, data breaches, or unauthorized access.
          </p>
          
          <p>
            <strong>3. Legal Exceptions:</strong> My data may be shared with law enforcement agencies if required by law, court order, or to assist in locating missing persons.
          </p>
          
          <p>
            <strong>4. Limitation of Liability:</strong> I waive and release MISYOU, its owners, directors, employees, and affiliates from any claims, damages, or compensation arising from:
          </p>
          <ul className="list-disc ml-6 space-y-1">
            <li>Data breaches or security incidents beyond reasonable control</li>
            <li>Unauthorized access to my information</li>
            <li>Loss or misuse of data by third parties</li>
          </ul>
          
          <p>
            <strong>5. Voluntary Use:</strong> I am using this platform voluntarily and at my own risk.
          </p>
        </div>
      </div>

      <div className="bg-red-100 border border-red-300 rounded-lg p-3 mb-4">
        <p className="text-red-800 text-sm font-medium flex items-start gap-2">
          <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
          <span>If you are unsure about these terms, DO NOT check this box and DO NOT use this platform.</span>
        </p>
      </div>

      <div className="flex items-start gap-3">
        <Checkbox
          id="data-security-consent"
          checked={checked}
          onCheckedChange={onCheckedChange}
          className="mt-1 border-amber-400 data-[state=checked]:bg-amber-600 data-[state=checked]:border-amber-600"
          data-testid="data-security-consent-checkbox"
        />
        <Label 
          htmlFor="data-security-consent" 
          className="text-sm font-semibold text-amber-900 cursor-pointer leading-relaxed"
        >
          I confirm that I have read, understood, and accept the Data Security & Liability Waiver terms stated above.
        </Label>
      </div>
    </div>
  );
}

export default DataSecurityConsent;
